import React from 'react';
import { IMultiUserDeletePopupProps } from './types';
import SimplePopup from '../SimplePopup';
import {
  ButtonRow,
  CancelButton,
  Container,
  DeleteButton,
  Image,
  PopupInviteBlock,
  PopupText,
  PopupTitle,
} from './styles';
import { EnumTheme } from '../../../constants/enums';
import productImageSrc from 'assets/images/product/default-product-image_1.png';
import { getPopUpSnapPoint } from '../../../utils/helpers';

export const MultiUserDeletePopup: React.FC<IMultiUserDeletePopupProps> = ({
  isShow,
  onClose,
  title,
  subTitle,
  onDelete,
  btnText = 'Удалить',
  closeBtnText = 'Не надо',
}) => {
  return (
    <SimplePopup show={isShow} close={onClose} snapPointToTop={getPopUpSnapPoint(340)}>
      <Container>
        <Image src={productImageSrc} />
        <PopupTitle>{title}</PopupTitle>
        <PopupInviteBlock>
          <PopupText>{subTitle}</PopupText>
          <ButtonRow>
            <CancelButton use={EnumTheme.roundGhostGray} onClick={onClose}>
              {closeBtnText}
            </CancelButton>
            {onDelete && <DeleteButton onClick={onDelete}>{btnText}</DeleteButton>}
          </ButtonRow>
        </PopupInviteBlock>
      </Container>
    </SimplePopup>
  );
};
